export default __webpack_public_path__ + "static/partnerIcon21-e6fc1471e1b6beb803800028dab54696.svg";